import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { useMainPageState } from "../store/selectors";

import {
  capitalize,
  setFocus,
  validateURLMainPage,
  validateUnlocklabUrl,
} from "../utils/helpers";

export const useMainForm = url => {
  const { t } = useTranslation();

  const urlRef = useRef(null);
  const userAgentRef = useRef(null);
  const countryRef = useRef(null);

  const [formData, setFormData] = useState({
    url,
    proxyServerId: "",
    fingerprintUserAgent: "",
    removePageTitle: false,
    allowCookies: true,
    deleteScripts: false,
    // encryptPage: false,
    // permanentUrls: false,
  });

  const { mainPageData, isLoading } = useMainPageState();

  const capitalizeDataCountry = useMemo(
    () =>
      mainPageData?.proxyServers?.map(el => ({
        ...el,
        name: capitalize(el.name),
      })),
    [mainPageData?.proxyServers],
  );

  useEffect(() => {
    if (!url) return;
    setFormData(prevFormData => ({
      ...prevFormData,
      url,
    }));
  }, [url]);

  const handleChange = event => {
    const { name, value } = event.target;
    setFormData(prevFormData => ({ ...prevFormData, [name]: value }));
  };

  const handleCheckboxChange = event => {
    const { name, checked } = event.target;

    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: checked,
    }));
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (!formData.url.trim()) {
      setFocus(urlRef);
      return;
    }

    // --------------------------------------------------------------
    // variant 1
    // *** set default values for proxyServerId and fingerprintId ***
    // --------------------------------------------------------------
    // setFormData((prevFormData) => ({
    //   ...prevFormData,
    //   proxyServerId: mainPageData.proxyServers[0].id,
    //   fingerprintId: mainPageData.fingerprints[0].id,
    // }));

    // ---------------------------------------------------------------
    // variant 2
    // *** check other fields ***
    // ---------------------------------------------------------------
    if (!formData.fingerprintUserAgent) {
      setFocus(countryRef);
      return;
    }
    if (!formData.proxyServerId) {
      setFocus(userAgentRef);
      return;
    }

    if (!validateURLMainPage(formData.url)) {
      toast.error(t("httpHeaders.invalidUrl"));
      return;
    }

    if (validateUnlocklabUrl(formData.url)) {
      toast.error(t("global.unlocklabNotAllowed"));
      return;
    }

    event.target.submit();
  };
  return {
    formData,
    handleSubmit,
    handleChange,
    handleCheckboxChange,
    urlRef,
    countryRef,
    userAgentRef,
    mainPageData,
    capitalizeDataCountry,
    isLoading,
  };
};
